import React, { useMemo } from 'react'
import "./resultHeader.scss"
import { useSelector } from 'react-redux'
import { SelectNextGameTime, SelectLastWinCard } from '../../../redux/2d-slice/gameInfo2dSlice'
import {
    SelectActiveSeriesIndex
} from "../../../redux/2d-slice/seriesSlice2d";
import moment from 'moment'

function ResultHeader() {
    const activeSeriesIndex = useSelector(SelectActiveSeriesIndex);
    let currentDrawTime = useSelector(SelectNextGameTime)
    let last_win_cards = useSelector(SelectLastWinCard)
    const ALL_NUMBERS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let resultCard = useMemo(() => {
        if (last_win_cards.length) {
            return last_win_cards[last_win_cards.length - 1]; // latest
        }
    }, [last_win_cards])

    const getNumberColor = (num) => {
        const str = String(num);
        if (str.length >= 2 && str[str.length - 1] === str[str.length - 2]) {
            return 'red';       // last 2 same
        }
        return '#000';      // blue (या 'black')
    };

    return (
        <>
            <style>{`
                .hover-table {
                    border-collapse: collapse;
                    width: 100%;
                }

                .hover-table th,
                .hover-table td {
                    border: 1px solid #ddd;
                    /*padding: 8px;
                    text-align: left;*/
                }

                .hover-table tr:first-child {
                    display: table-row;
                    /* Show first row by default */
                }

                .hover-table tr:nth-child(n+2) {
                    display: none;
                    /* Hide other rows by default */
                }

                .hover-table:hover tr:first-child {
                    display: none;
                    /* Hide first row on hover */
                }

                .hover-table:hover tr:nth-child(n+2) {
                    display: table-row;
                    /* Show other rows on hover */
                }

                .hover-table:not(:hover) tr:first-child {
                    display: table-row;
                }

                .hover-table:not(:hover) tr:nth-child(n+2) {
                    display: none;
                }

                .hover-table th {
                    /*background-color: #f2f2f2;*/
                }

                .bg-color-1 { background: #a2da17; } .bg-color-2 { background: #01b0f1; } .bg-color-3 { background: #FFFF00; } .bg-color-4 { background: #f4b084; } .bg-color-5 { background: #c6e0b4; } .bg-color-6 { background: #ffd966; } .bg-color-7 { background: #9dc3e6; } .bg-color-8 { background: #d9d2e9; } .bg-color-9 { background: #f8cbad; } .bg-color-10 { background: #b4c6e7; }
            `}</style>
            {/* <div className='result_div'> */}
            {/*  */}

            <table width="100%" height="100%" align="left">
                <tbody>
                    <tr>
                        <th width="5%" className='result_head' style={{ backgroundColor: "#a2da17", fontSize: '12px', border: '1px solid #000' }}>
                            Result: {currentDrawTime ? moment(currentDrawTime, 'h:mm A').subtract(30, 'minute').format('hh:mm A') : ''}
                            {/* <span className='preDrawTime'>1:15 PM</span> */}
                            {/* <span className='preDrawTime'></span> */}
                        </th>
                        {/*  */}
                        {resultCard &&
                            <>
                                {ALL_NUMBERS.map((digit, index) => {
                                    const number = resultCard?.[activeSeriesIndex]?.[digit];
                                    const textColor = number ? getNumberColor(number) : '#000';

                                    return (
                                        <th
                                            key={digit}
                                            width="5%"
                                            className={`bg-color-${index + 1}`}
                                            style={{
                                                color: textColor,
                                                border: '1px solid #000'
                                            }}
                                        >
                                            {number ?? '-'}
                                        </th>
                                    );
                                })}
                            </>
                        }
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default ResultHeader